import React from 'react'
import MissionVision from '../home/MissionVision'
import Opportunities from '../home/Opportunities'
import { Link } from "react-router-dom";


const DirectorMessage = () => {
  return (
    <>
      <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Director Message</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active" style={{ color: "red" }}>Director Message</li>
          </ul>
        </div>
      </div>


      <div className="team-single pt-120 pb-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="team-single-img">
                <img src="assets/school/Priya Chauhan.webp" alt />
              </div>
            </div>
            <div className="col-md-8">
              <div className="team-details">
                <h3>Mrs. Priya Chauhan</h3>
                <strong>Director Message</strong>
                <p className="mt-3" style={{ textAlign: "justify" }}>
                  Education is not merely the acquisition of knowledge, but the development of character, discipline, and values that shape responsible individuals and future leaders. At our school, we are committed to providing an environment where academic excellence goes hand in hand with moral integrity and holistic growth.
                  Our aim is to nurture young minds with curiosity, creativity, and confidence, enabling them to face global challenges with courage and compassion. We believe that every child is unique, and with the right guidance, encouragement, and opportunities, each student can realize their true potential.
                </p>
                <div className="team-details-info">
                  <ul>
                    <li>
                      <Link to="https://share.google/Fsl3aMdnrCaBHv8Ae" target="_blank"><i className="far fa-location-dot" /> Swami Chowk, Mukhtiyarganj Satna (M.P.)</Link>
                    </li>
                    <li>
                      <Link to="mailto:pchs.satna@gmail.com"><i className="far fa-envelopes" /> pchs.satna@gmail.com</Link>
                    </li>
                    <li>
                      <Link to="tel:7987105491"><i className="far fa-phone-volume" /> +91 7987105491</Link>
                    </li>
                  </ul>
                </div>
                <div className="team-details-social">
                  <Link to="https://www.facebook.com/Pchs.satna/" target="_blank"><i className="fab fa-facebook-f" /></Link>
                  <Link to="https://wa.me/917987105491"><i className="fab fa-whatsapp" target="_blank" /></Link>
                  <Link to="https://www.instagram.com/pchschool?igsh=MTVpdHltbDl3N2lxbw=="><i className="fab fa-instagram" target="_blank" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="biography-skil pb-120">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="biography">
                {/* <h4 className="mb-3">Biography</h4> */}
                <p className="mb-10" style={{ textAlign: "justify" }}>
                  Parents are our valued partners in this journey of education. Together, through mutual trust and cooperation, we can create a strong foundation for our children’s success.
                  Through a balanced blend of modern education, co-curricular activities, and strong value-based learning, we strive to prepare our students not only for examinations, but for life itself. Our dedicated teachers, supportive parents, and enthusiastic students together form the strong foundation of our institution.
                  I extend my heartfelt gratitude to all parents for trusting us with the future of their children. Let us work together to inspire excellence, nurture values, and build a brighter tomorrow.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="team-skill">
                <h4 className="mb-3">Professional Skills</h4>
                <div className="skills-section">
                  <div className="progress-box">
                    <h5>Communication <span className="pull-right">99%</span></h5>
                    <div className="progress" data-value={99}>
                      <div className="progress-bar" role="progressbar" style={{ width: '99%' }} />
                    </div>
                  </div>
                  <div className="progress-box">
                    <h5>Relationship <span className="pull-right">98%</span></h5>
                    <div className="progress" data-value={98}>
                      <div className="progress-bar" role="progressbar" style={{ width: '98%' }} />
                    </div>
                  </div>
                  <div className="progress-box">
                    <h5>Creative Work <span className="pull-right">99%</span></h5>
                    <div className="progress" data-value={99}>
                      <div className="progress-bar" role="progressbar" style={{ width: '99%' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default DirectorMessage